import MeldeInteresseSkjemaModal from './melde-interesse-skjema-modal';

export default MeldeInteresseSkjemaModal;
